<template>
	<div class="ptrl-20-16 box-s pb-20">
		 <ul class="list_every plr-16 box-s bg_f">
       <li class="flexs flex-jus bb-E every_wrong fz-14 h60 box-s" v-for="(item, index) in list" :key="index" @click="getMyWrong(item)">
				 <div class="c1">{{item.subject_name}}</div>
				 <div class="flexs">
					 <div class="c3 mr-10">{{item.numbers}}道题</div>
					 <img class="wh_8_14" src="../../assets/img/icon/gray_kong_arrow.png" alt="">
				 </div>
			 </li>
		 </ul>
		 <noData v-if="show"></noData>
		 <loading :loadFlag="loadFlag"></loading>
	</div>

</template>
<script>
  import noData from "@/components/noData"
  import loading from "@/components/loading"
  import { myMistake } from '@/api/api.js'
	export default {
		components: {
      noData,
			loading
		},
		data() {
			return {
				list: [],
				show: false,
				loadFlag: false
			};
		},
		created() {
      this.initData()
		},
		methods: {
		  async initData(){
				this.loadFlag = true
        const res = await myMistake()
				this.loadFlag = false
				if(res.code == 1000){
          this.list = res.data
					if(this.list.length == 0){
						this.show = true
					}
				} else {
					this.$toast(res.msg)
				}
			},

			getMyWrong(item){
				if(item.numbers == 0){
          return this.$toast('暂无错题，无法查看哦~')
				}
        this.$router.push({ path: '/wrongquest', query: { subject_id: item.id } })
			}
		}
	}
</script>
<style lang="less" scoped>
.every_wrong:last-child {
  border: none;
}

.maxh {
	max-height: 100%;
}
.maxh::-webkit-scrollbar{
    display: none;
}
</style>
